import { Star, ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const GOOGLE_G = (
  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
    <path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.3-2.2H12v4.1h6.5c-.1 1.1-.8 2.7-2.4 3.8l-.1.1 3.6 2.8.2.1c2.1-1.9 3.3-4.8 3.3-8.4z" />
    <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.8-2.9c-1 .7-2.4 1.2-4.1 1.2-3.1 0-5.8-2.1-6.8-5l-.2.1-3.8 2.9v.1C3.2 21.4 7.3 24 12 24z" />
    <path fill="#FBBC05" d="M5.2 14.4c-.2-.7-.4-1.5-.4-2.4s.1-1.7.4-2.4v-.1L1.3 6.5 1.2 6.6C.4 8.2 0 10 0 12s.4 3.8 1.2 5.4l4-3z" />
    <path fill="#EA4335" d="M12 4.7c2.3 0 3.8 1 4.7 1.8l3.4-3.3C18.9 1.2 15.2 0 12 0 7.3 0 3.2 2.6 1.2 6.6l4 3c1-2.9 3.7-5 6.8-5z" />
  </svg>
);

const GoogleBadge = () => (
  <a
    data-testid="google-rating-badge"
    href="https://www.google.com/search?q=After+Paint+Yamba+reviews"
    target="_blank"
    rel="noopener noreferrer"
    className="group flex items-center gap-6 border border-line px-7 py-5 hover:border-ember/60 hover:-translate-y-0.5 transition-[border-color,transform] duration-300"
  >
    <span className="shrink-0">{GOOGLE_G}</span>
    <span>
      <span className="flex items-baseline gap-3">
        <span className="font-serif font-light text-4xl leading-none">5.0</span>
        <span className="flex gap-1">
          {Array.from({ length: 5 }).map((_, s) => (
            <Star key={s} size={13} className="fill-ember text-ember" strokeWidth={1} />
          ))}
        </span>
      </span>
      <span className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-smoke mt-2">
        Rated on Google · 3 reviews
        <ArrowUpRight
          size={12}
          strokeWidth={1.5}
          className="text-ember opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        />
      </span>
    </span>
  </a>
);

const REVIEWS = [
  {
    quote:
      "Craig was very efficient and on time, a very good painter — and a lovely person.",
    name: "Lyn Abraham",
    testid: "review-lyn",
  },
  {
    quote:
      "An excellent painter. He is particular, and his thirty years as a painter shows in his work. I would highly recommend.",
    name: "Jeanette Buckman",
    testid: "review-jeanette",
  },
  {
    quote: "Very happy with this company's services.",
    name: "Mathew Sioud",
    testid: "review-mathew",
  },
];

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 border-t border-line"
    >
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
        <div>
          <Reveal>
            <SectionLabel>Word of Mouth</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-8">
              What clients <span className="italic text-smoke">say.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <GoogleBadge />
        </Reveal>
      </div>

      <div className="mt-20">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.08}>
            <figure
              data-testid={r.testid}
              className="grid md:grid-cols-12 gap-6 md:gap-12 py-12 md:py-14 border-t border-line"
            >
              <div className="md:col-span-8">
                <div className="flex gap-1.5 mb-6">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star
                      key={s}
                      size={14}
                      className="fill-ember text-ember"
                      strokeWidth={1}
                    />
                  ))}
                </div>
                <blockquote className="font-serif italic font-light text-2xl md:text-3xl lg:text-4xl leading-snug text-bone/90 tracking-tight">
                  "{r.quote}"
                </blockquote>
              </div>
              <figcaption className="md:col-span-4 flex md:justify-end items-end">
                <div className="md:text-right">
                  <p className="text-xs uppercase tracking-[0.25em] font-semibold text-bone">
                    {r.name}
                  </p>
                  <p className="text-xs uppercase tracking-[0.2em] text-smoke mt-2">
                    Residential client
                  </p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
